module.exports = __webpack_public_path__ + "static/media/retornavel-logo.b3588091.png";